import React, { FC } from "react";
import { TableCell as MuiTableCell, TableCellProps } from "@mui/material";

const TableCell: FC<TableCellProps> = (props) => <MuiTableCell {...props} />;

export default TableCell;
